import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5712">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5713">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5714">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5715">
            <ArrowLeft className="w-4 h-4" data-id="element-5716" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5717">NOIZA</div>
          <div className="w-20" data-id="element-5718" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5719">
        <div className="mb-12" data-id="element-5720">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5721">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5722" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5723">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5724">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5725">
          <section data-id="element-5726">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5727">
              <span className="text-[#006847]" data-id="element-5728">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5729">
              <p data-id="element-5730">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5731">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5732">
                <li data-id="element-5733">Haber leído íntegramente este documento</li>
                <li data-id="element-5734">Comprender su contenido en su totalidad</li>
                <li data-id="element-5735">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5736">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5737">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5738">
              <span className="text-[#006847]" data-id="element-5739">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5740">
              <p data-id="element-5741">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5742">
                <li data-id="element-5743">Software como servicio (SaaS)</li>
                <li data-id="element-5744">Marketplace digital gastronómico</li>
                <li data-id="element-5745">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5746">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5747">
                <li data-id="element-5748">Mostrar su menú digital</li>
                <li data-id="element-5749">Recibir pedidos de clientes</li>
                <li data-id="element-5750">Gestionar su operación interna</li>
                <li data-id="element-5751">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5752">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5753">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5754">
              <span className="text-[#006847]" data-id="element-5755">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5756">
              <p data-id="element-5757">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5758">
                <li data-id="element-5759">No es proveedor de alimentos</li>
                <li data-id="element-5760">No participa en la preparación de productos</li>
                <li data-id="element-5761">No manipula alimentos en ningún momento</li>
                <li data-id="element-5762">No realiza entregas ni logística</li>
                <li data-id="element-5763">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5764">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5765">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5766">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5767">
              <span className="text-[#006847]" data-id="element-5768">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5769">
              <p data-id="element-5770">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5771">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5772">
                <li data-id="element-5773">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5774">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5775">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5776">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5777">
                <li data-id="element-5778">Precios</li>
                <li data-id="element-5779">Menú</li>
                <li data-id="element-5780">Horarios</li>
                <li data-id="element-5781">Métodos de pago</li>
                <li data-id="element-5782">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5783">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5784">
              <span className="text-[#006847]" data-id="element-5785">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5786">
              <div data-id="element-5787">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5788">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5789">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5790">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5791">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5792">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5793">
                  <li data-id="element-5794">Calidad de los alimentos</li>
                  <li data-id="element-5795">Estado, frescura o preparación</li>
                  <li data-id="element-5796">Ingredientes utilizados</li>
                  <li data-id="element-5797">Contaminación cruzada</li>
                  <li data-id="element-5798">Problemas de higiene o salubridad</li>
                  <li data-id="element-5799">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5800">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5801">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5802">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5803">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5804">
                  <li data-id="element-5805">Retrasos en la entrega</li>
                  <li data-id="element-5806">Pérdida de pedidos</li>
                  <li data-id="element-5807">Entregas incompletas</li>
                  <li data-id="element-5808">Errores en dirección</li>
                  <li data-id="element-5809">Conducta de repartidores</li>
                  <li data-id="element-5810">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5811">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5812">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5813">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5814">
                  <li data-id="element-5815">Recepción de pagos</li>
                  <li data-id="element-5816">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5817">Manejo de efectivo</li>
                  <li data-id="element-5818">Confirmación de pagos</li>
                  <li data-id="element-5819">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5820">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5821">
                  <li data-id="element-5822">Pagos no recibidos</li>
                  <li data-id="element-5823">Comprobantes falsos</li>
                  <li data-id="element-5824">Errores en montos</li>
                  <li data-id="element-5825">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5826">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5827">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5828">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5829">
                  <li data-id="element-5830">Reclamos de clientes</li>
                  <li data-id="element-5831">Reembolsos</li>
                  <li data-id="element-5832">Cancelaciones</li>
                  <li data-id="element-5833">Disputas</li>
                  <li data-id="element-5834">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5835">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5836">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5837">
              <span className="text-[#006847]" data-id="element-5838">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5839">
              <p data-id="element-5840">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5841">
                <li data-id="element-5842">Responsable</li>
                <li data-id="element-5843">Legal</li>
                <li data-id="element-5844">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5845">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5846">
                <li data-id="element-5847">Publicar información falsa</li>
                <li data-id="element-5848">Manipular precios de forma engañosa</li>
                <li data-id="element-5849">Simular disponibilidad inexistente</li>
                <li data-id="element-5850">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5851">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5852">
              <span className="text-[#006847]" data-id="element-5853">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5854">
              <p data-id="element-5855">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5856">
                <li data-id="element-5857">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5858">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5859">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5860">
                <li data-id="element-5861">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5862">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5863">
                    <li data-id="element-5864">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5865">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5866">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5867">
              <span className="text-[#006847]" data-id="element-5868">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5869">
              <p data-id="element-5870">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5871">
                <li data-id="element-5872">Menú digital</li>
                <li data-id="element-5873">Gestión de pedidos</li>
                <li data-id="element-5874">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5875">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5876">
                  <p className="font-medium text-white mb-2" data-id="element-5877">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5878">
                    <li data-id="element-5879">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5880">
                  <p className="font-medium text-white mb-2" data-id="element-5881">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5882">
                    <li data-id="element-5883">Propiedad del software</li>
                    <li data-id="element-5884">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5885">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5886">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5887">
              <span className="text-[#006847]" data-id="element-5888">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5889">
              <p data-id="element-5890">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5891">
                <li data-id="element-5892">Disponibilidad continua</li>
                <li data-id="element-5893">Funcionamiento sin interrupciones</li>
                <li data-id="element-5894">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5895">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5896">
                <li data-id="element-5897">Fallas técnicas</li>
                <li data-id="element-5898">Actualizaciones</li>
                <li data-id="element-5899">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5900">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5901">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5902">
              <span className="text-[#006847]" data-id="element-5903">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5904">
              <p data-id="element-5905">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5906">
                <li data-id="element-5907">No está garantizada permanentemente</li>
                <li data-id="element-5908">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5909">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5910">
                <li data-id="element-5911">Destacar o no restaurantes</li>
                <li data-id="element-5912">Modificar posiciones</li>
                <li data-id="element-5913">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5914">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5915">
              <span className="text-[#006847]" data-id="element-5916">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5917">
              <p data-id="element-5918">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5919">
                <li data-id="element-5920">Cumplir con los pagos acordados</li>
                <li data-id="element-5921">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5922">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5923">
                <li data-id="element-5924">Suspender el servicio</li>
                <li data-id="element-5925">Limitar funcionalidades</li>
                <li data-id="element-5926">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5927">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5928">
              <span className="text-[#006847]" data-id="element-5929">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5930">
              <p data-id="element-5931">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5932">
                <li data-id="element-5933">Incumplimiento de términos</li>
                <li data-id="element-5934">Uso indebido</li>
                <li data-id="element-5935">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5936">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5937">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5938">
              <span className="text-[#006847]" data-id="element-5939">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5940">
              <p data-id="element-5941">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5942">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5943">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5944">
              <span className="text-[#006847]" data-id="element-5945">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5946">
              <p data-id="element-5947">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5948">
                <li data-id="element-5949">Pérdidas económicas</li>
                <li data-id="element-5950">Daños indirectos</li>
                <li data-id="element-5951">Lucro cesante</li>
                <li data-id="element-5952">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5953">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5954">
              <span className="text-[#006847]" data-id="element-5955">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5956">
              <p data-id="element-5957">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5958">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5959">
              <span className="text-[#006847]" data-id="element-5960">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5961">
              <p className="font-medium" data-id="element-5962">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5963">
                <li data-id="element-5964">Ha leído este documento completo</li>
                <li data-id="element-5965">Comprende su alcance</li>
                <li data-id="element-5966">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}